import React, { Component } from 'react'
import { Table, Layout, Spin, PageHeader, Form, Upload, Input, Switch } from 'antd'
import { getGoodDetail } from '../../api/api'
import PrevImg from '_src/components/PrevImg/PrevImg'
import './detail.less'

// 所属专题、站点可能为空，暂时隐藏；需要展示时改为 true
const SHOW_TOPIC_AND_STATION = false

const getStatus = status => {
  switch (status) {
  case -2:  
    return '待审核'  
  case -1:
    return '审核不通过'
  case 0:
    return '审核通过'
  case 1:
    return '上架中' 
  case 2:
    return '下架'
  case 3:
    return '删除'
  default: 
    return '--'
  }
}

export default class Detail extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isLoading: true,
    }
    this.columns = [
      {
        title: '规格',
        align: 'left',
        width: 200,
        key: 'id',
        dataIndex: 'specificationsName',
      },
      {
        title: '售价（元）',
        align: 'center',
        dataIndex: 'salePrice',
        render: item => (item / 100).toFixed(2) + '元'
      },
      {
        title: '原价（元）',
        align: 'center',
        dataIndex: 'originalPrice',
        render: item => (item / 100).toFixed(2) + '元'
      },
      {
        title: '底价（元）',
        align: 'center',
        dataIndex: 'floorPrice',
        render: item => (item / 100).toFixed(2) + '元'
      },
      {
        title: '库存',
        align: 'center',
        dataIndex: 'number',
      },
      {
        title: '交易成功',
        align: 'center',
        dataIndex: 'volume',
        render: item => item || 0
      },
    ]
  }

  componentWillMount () {
    const id = this.props.location.search.replace('?id=', '')
    getGoodDetail({id})
      .then(res => {
        if (res) {
          const data = res.data
          const picUrlArr = this.getImgFile([data.picUrl])
          const ImgArr = this.getImgFile(JSON.parse(data.gallery))
          this.setState(() => ({
            isLoading: false,
            info: data,
            picUrlArr,
            ImgArr,
            id,
          }))
        }
      })
  }

  getImgFile (arr) {
    return arr.map((item, index) => ({
      uid: index, 
      name: index + '.png', 
      status: 'done', 
      url: item
    }))
  }

  handlePreview = (file) => this.PrevImg.show(file.url)

  render () {
    const { 
      isLoading, 
      info, 
      picUrlArr,
      ImgArr,
    } = this.state
    return (
      <Layout className='goods-detail-page'>
        {isLoading ? <Spin t1ip="Loading..." className="loading" size='large' /> : ''}
        <PrevImg ref={el => this.PrevImg = el} />
        <PageHeader className='flex-h-a' title='商品详情' style={{borderLeft: '5px solid #1890ff', height: 30}} />
        {info && (
          <Form className="page-content" onSubmit={this.handleSubmit} style={{paddingLeft: 50, padddingRight: 50}}>
            <PageHeader title='基本信息' style={{paddingLeft: 0}} />
            <Form.Item label="商品名称：" className='flex'>
              <Input value={info.goodsName} style={{width: 600}} readOnly />
            </Form.Item>
            <Form.Item label="商品编号：" className='flex'>
              <Input value={info.goodsSn} style={{width: 600}} readOnly />
            </Form.Item>
            <Form.Item label="商品状态：" className='flex'>
              <Input value={getStatus(info.status)} style={{width: 600}} readOnly />
            </Form.Item>
            <Form.Item label="商品单位：" className='flex'>
              <Input value={info.unit} style={{width: 600}} readOnly />
            </Form.Item>
            <Form.Item label="商品分类：" className='flex'>
              <Input value={(info.goodsCategory && info.goodsCategory.name) || '--'} style={{width: 600}} readOnly />
            </Form.Item>
            {SHOW_TOPIC_AND_STATION && (
              <>
                <Form.Item label="所属专题：" className='flex'>
                  <Input value={(info.goodsTopic && info.goodsTopic.name) || '--'} style={{width: 600}} readOnly />
                </Form.Item>
                <Form.Item label="站点：" className='flex'>
                  <Input value={(info.station && info.station.name) || '--'} style={{width: 600}} readOnly />
                </Form.Item>
              </>
            )}
            <Form.Item label="用户收藏次数：" className='flex'>
              <Input value={info.collect || 0} style={{width: 600}} readOnly />
            </Form.Item>
            <Form.Item label="用户分享次数：" className='flex'>
              <Input value={info.share || 0} style={{width: 600}} readOnly />
            </Form.Item>
            <Form.Item label="商品规格：" className='flex'>
              <Table
                className='space-inner'
                style={{width: 800}}
                bordered
                rowKey='id'
                columns={this.columns}
                dataSource={info.goodSpecifications}
                pagination={false}
              />
            </Form.Item>
            <Form.Item label="商品短视频：" className='flex' style={{marginTop: 30}}>
              {
                info.videoUrl 
                  ? <video style={{width: 600}} id="cloth-video" src={info.videoUrl} controls autoPlay muted playsInline />
                  : '无'
              }
            </Form.Item>
            <Form.Item label="商品封面：" className='flex'>
              <Upload
                action=""
                listType="picture-card"
                fileList={picUrlArr}
                onPreview={this.handlePreview}
                onRemove={() => { return false }}
              />
            </Form.Item>
            <Form.Item label="商品图片：" className='flex'>
              <Upload
                action=""
                listType="picture-card"
                fileList={ImgArr}
                onPreview={this.handlePreview}
                onRemove={() => { return false }}
              />
            </Form.Item>
            <Form.Item label="商品描述：" className='flex'>
              <div className="goods-desc" dangerouslySetInnerHTML={{__html: info.detail}} />
            </Form.Item>
            <PageHeader title='奖励积分规则' style={{paddingLeft: 0, marginTop: 20}} />
            <Form.Item label="是否派送积分：" className='flex'>
              <Switch disabled checked={!!info.goodsReward} checkedChildren="是" unCheckedChildren="否" onChange={(reward)=>{ debugger; this.setState({reward}) }} />
            </Form.Item>
            {
              !!info.goodsReward && (
                <div>
                  <Form.Item label="奖励积分总数：" className='flex'><Input value={info.goodsReward.totalCount || 0} style={{width: 600}} readOnly /></Form.Item>
                  <Form.Item label="剩余积分：" className='flex'><Input value={info.goodsReward.surplusCount || 0} style={{width: 600}} readOnly /></Form.Item>
                  <Form.Item label="浏览商品奖励规则：" className='flex'>
                    {
                      info.goodsReward.browsReward > 0 
                        ? <Input value={`浏览${info.goodsReward.browsCount}秒商品，奖励${info.goodsReward.browsReward}积分`} style={{width: 600}} readOnly />
                        : <Input value='无奖励' style={{width: 600}} readOnly />
                    } 
                  </Form.Item>
                  <Form.Item label="观看视频奖励：" className='flex'>
                    {
                      info.goodsReward.watchReward > 0
                        ? <Input value={`观看${info.goodsReward.watchCount}秒视频，奖励${info.goodsReward.watchReward}积分`} style={{width: 600}} readOnly />
                        : <Input value='无奖励' style={{width: 600}} readOnly />
                    } 
                  </Form.Item>
                </div>
              )
            }
          </Form>
        )}
      </Layout>
    )
  }
}